/**
 * 参考平面宿主面的稳定描述。
 *
 * 设计说明：
 * 1. 该描述用于把“草图参考平面”与“其来源实体面”建立稳定关联；
 * 2. 选择链路只依赖该稳定描述，不直接耦合具体的 FeatureFace 实例；
 * 3. 字段只保留最小真相，避免把临时运行态对象泄漏到领域层。
 */
export interface ReferencePlaneHostFaceDescriptor {
    /** 宿主实体结果体对象 ID。 */
    objectId: string;
    /** 宿主面的索引。 */
    faceIndex: number;
}

/**
 * 创建不可变的宿主面描述。
 *
 * 设计说明：
 * 1. 统一在底层冻结描述对象，避免外层误改参考平面元数据；
 * 2. 该函数仅负责最小字段复制，不做额外推断；
 * 3. 选择热路径可直接复用同一对象引用，避免重复分配。
 *
 * @param input 原始宿主面描述。
 * @returns 不可变宿主面描述。
 */
export function createReferencePlaneHostFaceDescriptor(
    input: ReferencePlaneHostFaceDescriptor,
): ReferencePlaneHostFaceDescriptor {
    return Object.freeze({
        objectId: input.objectId,
        faceIndex: input.faceIndex,
    });
}
